<template>
  <div>
    <ks-data-mode-crud-modal
        v-if="enableModes"
        :ref="id"
        :dataProvider="id"
    />
  </div>
</template>

<script>
import Vue from 'vue';
import listMixin from './mixins/list.mixin'
import recordMixin from './mixins/record.mixin'
import localRecordMixin from './mixins/localRecord.mixin'
import filterMixin from './mixins/filters.mixin'
import validationMixin from './mixins/validation.mixin'
import filesMixin from './mixins/files.mixin'
import componentsMixin from './mixins/components.mixin'
import modesMixin from './mixins/modes.mixin'
import paginationMixin from './mixins/pagination.mixin'
import listItemNavigationMixin from './mixins/listItemNavigation.mixin'
import apiCallsMixin from './mixins/apiCalls.mixin'

export default {
  name:     'data_provider',
  mixins:   [
    listMixin
    , recordMixin
    , localRecordMixin
    , filterMixin
    , validationMixin
    , filesMixin
    , filterMixin
    , componentsMixin
    , modesMixin
    , paginationMixin
    , listItemNavigationMixin
    , apiCallsMixin
  ],
  props:    {
    id:         {type: String, required: true},                                       // id key of the dataprovider must be unique
    dataSource: {type: String, required: true},                                       // string separate by points with the module name and source sproc to call 'module_name.source_sproc'

    // enable or disable flags
    enableLoadListOnMount:                 {type: Boolean, default: true},                                       // enable or disable default call to list when dataProvider is mounted
    enableLoadRecordOnMount:               {type: Boolean, default: true},                                       // enable or disable default call to read when dataProvider is mounted
    enableUrlModes:                        {type: Boolean, default: false},                                      // enable URL params filters to list -- includes modes and filters
    enableUpdateListItemOnRecordUpdate:    {type: Boolean, default: false},                                      // enable update list record
    enableInsertListItemOnRecordCreate:    {type: Boolean, default: false},                                      // enable create list record
    enableReadRecordOnListIndexChange:     {type: Boolean, default: false},                                      // enable read list record
    enableDeleteListItemOnRecordDelete:    {type: Boolean, default: false},                                      // enable delete list record
    enableModes:                           {type: Boolean, default: false},                                      // enable or disable modes
    enableLoadListOnCampaignChange:        {type: Boolean, default: false},                                      // enable or disable the call of the reload to list when the multiple campign change
    enableConfirmDisregardChanges:         {type: Boolean, default: false},                                      // enable or disable validate the record changes before save
    preventFormSubmitOnFilterChangeByCode: {type: Boolean, default: true},

    requireSingleFacilityId: {type: Boolean, default: false},                                      // if facility_id_csv exists, require it to only have one facility (TEMP WORKAROUND)
    requireSingleCampaignId: {type: Boolean, default: false},
    facility_type:           {type: String, default: 'string'},
    consoleLogs:             {type: Boolean, default: false},

//default data values
    dataProviderPermissions:               {
      type: Array, default: () => {
        return ['rms.authenticated']
      }
    },
    defaultConfirmDisregardChangesTitle:   {type: String, default: 'Are you certain?'},                          //default modal confirm title
    defaultConfirmDisregardChangesBody:    {type: String, default: '<div> Unsaved changes will be lost.</div>'}, //default modal confirm body (html)
    defaultConfirmDisregardChangesButtons: {
      type: Array, default: () => {
        return [
          {type: 'link', label: 'Close Anyway', value: true}, {
            type:  'warning',
            label: "Don't Close",
            value: false
          }]
      }
    },                                                                    //default modal confirm buttons
    defaultListItemIndexOnRecordCreate:    {type: Number, default: 0},                                           //default index to add the new record in the list array
    defaultModeName:                       {type: String, default: null},                                        //name of the default mode for load by default if is enable modes DEPRECIATED use id instead
    defaultModeId:                         {type: Number, default: null},                                        //id of the default mode for load by default if is enable modes
    defaultOrderBy:                        {type: String, default: null},                                        //string with the default order for the list
    defaultFilters:                        {
      type: Object, default: () => {
        return {}
      }
    },                           // default object with the filters for the list
    defaultReadFilters:                    {
      type: Object, default: () => {
        return {}
      }
    },                           // default object with the read parameters/filters for the load the read record
    defaultPage:                           {type: Number, default: 0},                                           // string with the default page of the list records
    defaultPageSize:                       {type: Number, default: 20},                                          // default number of records by page
    defaultRecord:                         {
      type: Object, default: () => {
      }
    },                                    // default record
    defaultRecordId:                       {type: Number, default: null},                                        // default record Id
    defaultRecordIdName:                   {type: String, default: null},                                        // key name with the id of the record
    defaultCampaignId:                     {type: Number, default: null},                                        // default Campaign Id
    defaultCampaignIdName:                 {type: String, default: 'campaign_id'},                               // key name with the id of the record
    defaultCreateResultSetName:            {type: String, default: 'create'},                                    //name of the resultset of the create a new record of the results returned by the API
    defaultListResultSetName:              {type: String, default: 'list'},                                      //name of the resultset of the list of the results returned by the API
    defaultReadResultSetName:              {type: String, default: 'read'},                                      //name of the resultset of the read of the results returned by the API
    defaultUpdateResultSetName:            {type: String, default: 'update'},                                    //name of the resultset of the update of the results returned by the API
    defaultDeleteResultSetName:            {type: String, default: 'delete'},                                    //name of the resultset of the delete a record the results returned by the API
    defaultCreateRecordIdNameOutput:       {type: String, default: 'id'},                                        // key name with the id of the record
    defaultReadRecordIdNameInput:          {type: String, default: null},                                        // key name with the id of the record
    defaultReadRecordIdNameOutput:         {type: String, default: 'id'},                                        // key name with the id of the record
    defaultUpdateRecordIdNameInput:        {type: String, default: null},                                        // key name with the id of the record
    defaultUpdateRecordIdNameOutput:       {type: String, default: 'id'},                                        // key name with the id of the record
    defaultListRecordIdNameInput:          {type: String, default: null},                                        // key name with the id of the record
    defaultListRecordIdNameOutput:         {type: String, default: 'id'},                                        // key name with the id of the record
    defaultDeleteRecordIdNameInput:        {type: String, default: null},                                        // key name with the id of the record
    defaultDeleteRecordIdNameOutput:       {type: String, default: 'id'},                                        // key name with the id of the record
    defaultCreateDataSource:               {type: String, default: null},
    defaultUpdateDataSource:               {type: String, default: null},
    defaultReadDataSource:                 {type: String, default: null},
    defaultListDataSource:                 {type: String, default: null},
    defaultDeleteDataSource:               {type: String, default: null},
    notifyEndUserOnErrorNumbers: {                                                                              // array of error numbers that if returned will show a toast with the error_text to the user
      type: Array, default: () => {
        return []
      }
    },

    // hooks
    hookBeforeCreate: {type: Function, default: null},                                      // exec actions before a call create
    hookBeforeList:   {type: Function, default: null},                                      // exec actions before a call list
    hookBeforeRead:   {type: Function, default: null},                                      // exec actions before a call read
    hookBeforeUpdate: {type: Function, default: null},                                      // exec actions before a call update
    hookBeforeDelete: {type: Function, default: null},                                      // exec actions before a call delete

    /* emits (events)
      onInsertRecord({createResultRecord}) => event triggered after a create/insert a new record, return the new record
      onListRecords({list: lisRecords, ResultSet: result set (pagination info) }) => event triggered after in a load of the list
      onReadRecord({record}) => event triggered in a load of read, return the record obtained
      onUpdateRecord({updateResultRecord}) => event triggered in a delete, return the response obtained
      onDeleteRecord({deleteResultRecord}) => event triggered in a delete, return the response obtained
      onLoad({this}) => event triggered after the load of the dataProvider
      onError({error}) => event triggered after an error in the dataProvider
    */
  },
  watch:    {
    // watching a boolean that triggers when the user changes campaigns rather than watching the campaign list, which changes on load
    // solves one of the double loading issues seen
    multi_campaign_input:  function (val, oldVal) {
      if (this.enableLoadListOnCampaignChange && !this.l_filters['campaign_id']) {
        if (this.l_campaignTimeoutRef) clearTimeout(this.l_campaignTimeoutRef);
        this.l_campaignTimeoutRef = setTimeout(() => {
          if (val !== oldVal) {
            if (this.consoleLogs) console.log("multi_campaign_input loadList");
            this.loadList(true);
            this.loadModeList();
          }
        }, 1250);
      }

    /*userSelectedCampaigns: function (val, oldVal) {
      if (this.enableLoadListOnCampaignChange && !this.l_filters['campaign_id']) {
        if (this.l_campaignTimeoutRef) clearTimeout(this.l_campaignTimeoutRef);
        this.l_campaignTimeoutRef = setTimeout(() => {
          if (val != oldVal) {*/
            //if (this.consoleLogs) console.log("userSelectedCampaigns loadList");
            //this.loadList(true);

          /*}
        }, 1250);
      }*/
    },
    //Instead of loading the lists from the Facility Selector, this watcher will load the lists (by updating Facility filters) but only if requireSingleFacilityId is true. Currently multi facility isn't supported.
    //removed based on Felipe's view
    /*selectedFacility:      function (val, oldVal) {
      console.log("selectedFacility", this.id, val, oldVal);
      if (val.id !== oldVal.id && this.requireSingleFacilityId) {
        console.log("this.id", this.id);
        this.updateFilters({'facility_id': val.id, 'facility_id_csv': val.id.toString()}, true);
        // this.loadQueryParams(true);
      }
    }*/
  },
  computed: {
    // simple count value that changes when the user interacts with the multi-campaign
    multi_campaign_input: {
      get() {
        return this.$store.state.rms_ui.auth.multi_campaign_input;
      },
      set(value) {
        this.$store.commit('rms_ui/auth/setMultiCampaignInput', value);
      }
    },
    //selectedFacility as a store variable, connected to here and the facility-selector
    selectedFacility: {
      get: () => {
        return app.store.state.ks_app.global_data.selectedFacility;
      },
      set: (value) => {
        app.store.commit('ks_app/global_data/setSelectedFacility', value);
      }
    },
    record:           {
      /*
        It is the record that will be used as the result of the reading if the data provider performs a read operation.
        On the other hand, it can be the creation or editing record that will be sent for
        the creation of a new record or the update of an existing one.
      */
      get() {
        return this.l_localRecord;
      },
      set(record) {
        this.l_localRecord = record;
      }
    },
    filters:          {
      /*
      Object with the parameters to filter the list. (the inputs of the store procedure for list)
      */
      get() {
        return this.l_filters;
      },
      set(filters) {
        this.l_filters = filters;
      }
    },
    inputs:           {
      /*
      Reference of the inputs defined in a form connected to the dataprovider to connect with a record property (Necessary for automatic validations)
      */
      get() {
        return this.l_inputs;
      },
      set(inputs) {
        this.l_inputs = inputs;
      }
    },
    list:             {
      /*
      List of records obtained of the call to API/SDK
      */
      get() {
        return this.l_list;
      },
      set(list) {
        this.l_list = list;
      }
    },
    result:           {
      /*
      Cache that stores the last complete response received from the API/SDK for read and list 
      */
      get() {
        return this.l_result;
      },
      set(result) {
        this.l_result = result;
      }
    },
    userCampaigns() {
      /*
      List of all campaigns of the current 
      */
      return app.auth.user.data_campaigns;
    },
    userSelectedCampaigns: {
      /*
      List of campaigns selected by the current 
      */
      get: function () {
        //app variable are not stable in updating computed properties. using store variable instead
        //return app.activeMultiCampaigns;
        return app.store.state.rms_ui.auth.selected_campaigns;
      }
    },
    dbName() {
      /*
      database name obtein in the datasource prop
      */
      try {
        return this.dataSource.split('.')[0];
      } catch (err) {
        console.warn(err);
        return "";
      }
    },
    dbTableName() {
      /*
      table name obtein in the datasource prop
      */
      try {
        return this.dataSource.split('.')[1];
      } catch (err) {
        console.warn(err);
        return "";
      }
    },
    isChangedLocalRecord() {
      /*
      Flag indicate if the record was 
      */
      return JSON.stringify(this.l_localRecord) !== JSON.stringify(this.l_originalRecord);
    }
  },
  methods:  {
    closeModeModal() {
      this.$refs[this.id].cancelMode();
    },
    openModeModal(type) {
      this.$refs[this.id].openModeModal(type);
    },
    async loadDefaultListReadData() {
      if (this.consoleLogs) console.log("loadDefaultListReadData");
      try {
        this.l_loading = true;
        if (this.enableModes) await this.loadModeList();
        //This (enableLoadListOnMount) has to be set to true for dataproviders with the requireSingleFacilityId set to true or it won't ever use the url queryParams
        if (this.enableLoadListOnMount) {
          if (this.enableUrlModes && this.$route.query.s) {
            await this.loadQueryParams();
          } else if (this.enableModes) {
            if (this.defaultModeName || this.defaultModeId) await this.selectDefaultMode(true);
            else await this.loadList(true);
          } else {
            await this.loadList(true);
          }
        } else if (this.defaultRecordId !== null && !isNaN(this.defaultRecordId) && this.defaultCampaignId !== null && this.enableLoadRecordOnMount) {
          await this.readRecord(this.defaultCampaignId, this.defaultRecordId, true, this.defaultReadFilters);
        }
        this.l_initialized = true;
        this.l_loading     = false;
        return true;
      } catch (err) {
        this.l_loading = true;
        console.log('KS-APP loadDefaultListReadData: ', this.id, err);
        throw err;
      }
    },
    async loadQueryParams(load = true) {
      //set mode from query params if it exists
      let queryStringObject = app.decodeQueryStringParams(this.$route.query.s);
      if (!queryStringObject && load) return await this.loadList(true);
      let updateFilters = true;  //=> this disables always the load of the filters by the query string if this.enableModes = true
                                 // CHARLES: I kept the else commented out so now it only sets this as false if queryStringObject.idMode exists -- should solve the double loading

      if (this.enableModes) {
        if (queryStringObject.idMode) {
          //added an explicit load param to the selectModeById function
          await this.selectModeById(queryStringObject.idMode, load);
          updateFilters = false;
        }/* else {
          await this.loadModeList();
          updateFilters = false;
        }*/
      }

      //load component configuration wait 500 ms for load the components this works only if the components are visible : needs review
      //was throwing a console error on queryStringObject.components, so put it in an if statement
      if (queryStringObject) {
        setTimeout(() => {
          this.setComponentsConfiguration(queryStringObject.components !== undefined ? queryStringObject.components : []);
        }, 1900);
      }

      //check if filter params campaign_id exists in activeMultiCampaigns and if not, set the filter params to null

      /*
      This not is necesary because now the campaign_id is not taken in filters.

      This need review because sharing the query/path with another user will not show the same results for both:
          In case User A shares with User B a url.
          1. User B either doesn’t have access to or hasn’t selected the same campaigns as User A.
          2. Is the mode_id of a data provider now applied at the user level? If so, modes cannot be shared by ID between users in the URL because they are not the same.

      if (queryStringObject.filters.campaign_id) {
        let found = app.activeMultiCampaigns.find(campaign => campaign.id === queryStringObject.filters.campaign_id);
        if (!found) {
          queryStringObject.filters.campaign_id = null;
        }
      }
      */
      //load filters parameters and pagination, after loadList
      if (updateFilters) { // => this disable the update filters --
        // CHARLES: BUT ONLY if it loads from a mode id in the query parms so loads the mode.
        if (this.consoleLogs) console.log("loadQueryParams updateFilters");
        await this.updateFilters(queryStringObject.filters !== undefined ? queryStringObject.filters : this.getFilters(), true, {
          'orderBy':  queryStringObject.orderBy !== undefined ? queryStringObject.orderBy : this.getOrderBy(),
          'pageSize': queryStringObject.pageSize !== undefined ? queryStringObject.pageSize : this.getPageSize(),
          'page':     queryStringObject.page !== undefined ? queryStringObject.page : this.getPage()
        });
      }
      return true;
    },
    // See Mixins for other methods
  },
  async mounted() {
    try {
      if (!app.dataproviders) app.dataproviders = {};
      this.setLocalRecord(this.getObjectTemplateByDefinitionType('create', this.defaultRecord));
      await this.setFilters(this.getObjectTemplateByDefinitionType('list', this.defaultFilters));
      app.addDataprovider(this.id, this);
      this.$emit('onMounted', this);
      await this.loadDefaultListReadData();
      this.$emit('onLoad', this);
    } catch (err) {
      console.log('KS-APP mounted: ', this.id, err);
      app.message(err, 'danger');
    }
  },
  beforeDestroy() {
    app.removeDataprovider(this.id);
  },
  data() {
    return {
      l_filters:                               {},
      l_files:                                 [],
      l_localRecord:                           {},
      l_originalRecord:                        {},
      l_list:                                  [],
      l_inputs:                                {},
      l_result:                                {list: [], read: []},
      l_initialized:                           false,
      l_preventFormSubmitOnFilterChangeByCode: false,
      l_campaignTimeoutRef:                    null,
      l_loading:                               false,
      l_components:                            []
    }
  }
}
</script>
